<template>
  <div id="balance" v-if="this.wallet">
    <i18n-n :value="wallet.availableBalance" :format="currencyFormatSettings" />
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { PaymentService } from 'Features/wallet/services/paymentService';
const { getWallet } = new PaymentService();

export default {
  async created() {
    if (this.businessProfileId) {
      await this.getWallet();
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'wallet',
      'currencyInfo',
      'roimaticConfiguration',
      'currencyFormatSettings',
      'isCurrencyCodeSet',
      'businessProfileId'
    ])
  },
  methods: {
    ...mapActions([
      'setWallet',
      'setIsLoading'
    ]),
    async getWallet() {
      let wallet = await getWallet(this.businessProfileId);
      this.setWallet(wallet);
      this.setIsLoading({ isWalletLoading: false });
    }
  }
};
</script>
<style lang="scss" scoped>
#balance {
  margin-right: 40px;
}
</style>
